import { render } from "./DigitCountButton.vue?vue&type=template&id=50513cba&scoped=true"
import script from "./DigitCountButton.vue?vue&type=script&lang=ts"
export * from "./DigitCountButton.vue?vue&type=script&lang=ts"

import "./DigitCountButton.vue?vue&type=style&index=0&id=50513cba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50513cba"

export default script